export default function lazyLoadImages() {
    // select both source and image elements
    var images = window.document.querySelectorAll('source, img');
    // Some config parameters for the IntersectionObserver
    var config = {
        // If the image gets within 30% in the Y axis, start the download.
        rootMargin: '30% 0px',
        threshold: 0.01,
    };
    // Set the src attribute with the value of the data-src attribute
    var preloadImage = function (element) {
        if (element.dataset && element.dataset.lazySrc) {
            element.src = element.dataset.lazySrc;
        }
        if (element.dataset && element.dataset.lazySrcset) {
            element.srcset = element.dataset.lazySrcset;
        }
    };
    var show = function (el) {
        el.classList.add('lazyloaded');
    };
    var onIntersection = function (entries, observer) {
        entries.forEach(function (entry) {
            var isIntersecting = entry.isIntersecting;
            var target = entry.target;
            if (isIntersecting) {
                // Stop watching and load the image
                observer.unobserve(target);
                // call our method: preloadImage
                preloadImage(target);
                if (target.src) {
                    var image_1 = target;
                    image_1.onload = function () { return show(image_1); };
                }
            }
        });
    };
    // If we don't have support for intersection observer, load the images immediately
    if (!('IntersectionObserver' in window)) {
        Array.from(images).forEach(function (image) { return preloadImage(image); });
    }
    else {
        // It is supported, load the images by calling our method: onIntersection
        var intersectionObserver_1 = new IntersectionObserver(onIntersection, config);
        images.forEach(function (image) {
            intersectionObserver_1.observe(image);
        });
    }
}
